import React, { useContext } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import Work1 from "../images/work1.jpg";
import Work2 from "../images/work2.jpg";
import {
  FaApple,
  FaGooglePlay,
  FaFacebookSquare,
  FaTwitterSquare,
  FaLinkedin,
  FaBookmark,
  FaCog,
  FaHandshake,
  FaUser,
} from "react-icons/fa";
import { MdMoneyOffCsred } from "react-icons/md";
import { TbPigMoney } from "react-icons/tb";
import { GiTakeMyMoney } from "react-icons/gi";

import { Link } from "react-router-dom";
import AOS from "aos";
import { AuthContext } from "../../utility/services/AuthContext";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const Team = () => {
  const { user } = useContext(AuthContext);
  // LOGICAL VARIABLES
  React.useEffect(() => {
    trackScreenView("team_screen", { screen_name: "Team", ...getUserTrackingParams(user) });
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);
  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={"Our Team"} />

      <section className="teamsection">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div class="team-member">
                <figure>
                  <img
                    src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                    alt=""
                    class="img-responsive"
                  />
                  <figcaption>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Recusandae asperiores mollitia.
                    </p>
                    <ul>
                      <li>
                        <a href="">
                          <FaFacebookSquare />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <FaTwitterSquare />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <FaLinkedin />
                        </a>
                      </li>
                    </ul>
                  </figcaption>
                </figure>
                <h4>Lauren Cox</h4>
                <p>Lorem Ipsum</p>
              </div>
            </div>
            <div className="col-md-4">
              <div class="team-member">
                <figure>
                  <img
                    src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                    alt=""
                    class="img-responsive"
                  />
                  <figcaption>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Recusandae asperiores mollitia.
                    </p>
                    <ul>
                      <li>
                        <a href="">
                          <FaFacebookSquare />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <FaTwitterSquare />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <FaLinkedin />
                        </a>
                      </li>
                    </ul>
                  </figcaption>
                </figure>
                <h4>Jessie Barnett</h4>
                <p>Lorem Ipsum</p>
              </div>
            </div>
            <div className="col-md-4">
              <div class="team-member">
                <figure>
                  <img
                    src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=461&q=80"
                    alt=""
                    class="img-responsive"
                  />
                  <figcaption>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Recusandae asperiores mollitia.
                    </p>
                    <ul>
                      <li>
                        <a href="">
                          <FaFacebookSquare />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <FaTwitterSquare />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <FaLinkedin />
                        </a>
                      </li>
                    </ul>
                  </figcaption>
                </figure>
                <h4>Terry Fletcher</h4>
                <p>Lorem Ipsum</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 howitwork">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3>HOW IT WORKS ?</h3>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-6 divider_a"
              data-aos="fade-down"
              data-aos-duration="2000"
              data-aos-delay="250"
            >
              <h4>
                For <span>Patients</span>
              </h4>
              <div className="mediaBox">
                <img src={Work1} alt="" />
                <p>
                  Welcome to eCareTherapy, where your mental well-being is our
                  top priority. Here's why choosing eCareTherapy can help you
                  free your mind and find the support you need
                </p>
              </div>
              <h5>
                <FaUser />
                <span>Choose your own therapist</span>
              </h5>
              <p className="mb-4">
                Browse therapist profiles, bios, genders, languages spoken,
                pricing, and ratings to find a therapist you can genuinely
                connect with.
              </p>
              <h5>
                <FaBookmark />
                <span>Flexibility to rebook and switch therapists</span>
              </h5>
              <p className="mb-4">
                If you find a therapist that resonates with you, you can easily
                rebook with them. Alternatively, you have the freedom to choose
                another therapist if needed.
              </p>
              <h5>
                <MdMoneyOffCsred />
                <span>No subscription required</span>
              </h5>
              <p className="mb-4">
                Unlike other platforms, we don't require costly subscriptions,
                allowing you to access the support you need without financial
                burden.
              </p>
              <h5>
                <FaHandshake />
                <span>Empowerment to find your ideal support</span>
              </h5>
              <p className="mb-4">
                By eliminating the need for subscriptions, eCareTherapy puts the
                power back in your hands, allowing you to freely explore and
                select the therapist who best aligns with your unique needs and
                preferences.
              </p>
              <Link to="" className="btn btn-primary me-3">
                For iOS <FaApple />
              </Link>

              <Link to="" className="btn btn-primary">
                For Android <FaGooglePlay />
              </Link>
            </div>
            <div
              className="col-md-6"
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-delay="250"
            >
              <h4>
                For <span>Therapists</span>
              </h4>
              <div className="mediaBox">
                <img src={Work2} alt="" />
                <p>
                  We provide therapists with a flexible and supportive
                  environment, enabling them to set their own rates, manage
                  their schedules, and connect with clients through secure
                  video, audio, or chat sessions. With immediate payments and no
                  subscription fees, eCareTherapy empowers therapists to focus
                  on what they do best – providing exceptional care to those in
                  need.
                </p>
              </div>
              <h5>
                <TbPigMoney />
                <span>Set Your Own Rates</span>
              </h5>
              <p className="mb-4">
                With eCareTherapy, you have the freedom to set your rates,
                starting from $39 for a 30-minute session or $59 for a 1-hour
                session, or higher if you wish. This flexibility allows you to
                align your pricing with your expertise and the value you
                provide, without compromising the market pricing for mental
                health services.
              </p>
              <h5>
                <FaCog />
                <span>Fast and Easy Setup</span>
              </h5>
              <p className="mb-4">
                Creating a profile and starting to earn through eCareTherapy is
                a seamless process that takes just a few minutes. Once your
                profile is live, you can immediately start accepting bookings
                and providing your services to clients.
              </p>
              <h5>
                <GiTakeMyMoney />
                <span>Immediate Payments</span>
              </h5>
              <p className="mb-4">
                At eCareTherapy, we understand the importance of timely
                compensation. As each session is booked and completed, you
                receive immediate payment, with 80% of the session fee going
                directly to you. This streamlined payment process ensures that
                you are fairly compensated for the services you provide.
              </p>

              <Link to="" className="btn btn-primary me-3">
                For iOS <FaApple />
              </Link>

              <Link to="" className="btn btn-primary">
                For Android <FaGooglePlay />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;
